import { createContext } from '@lit/context';

export type Locale = {
  setLocale: (newLocale: string) => Promise<void>;
  getLocale: () => string;
};

export const localeContext = createContext<Locale>(Symbol('locale'));
